import { Select as AntSelect } from 'antd';
import { SelectProps } from 'antd/lib/select';
import styled, { css, StyledComponent } from 'styled-components';

interface ICustomSelect extends SelectProps {
  active?: boolean;
}

export const RuleBuilderContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  padding: 0 8px;
`;

export const RuleBuilderTitle: StyledComponent<'div', any, { focus?: boolean }> = styled.div<{
  focus?: boolean;
}>`
  color: rgba(0, 0, 0, 0.65);

  ${({ focus }) => {
    if (focus) {
      return css`
        color: #0046ff;
      `;
    }
    return;
  }}
`;

export const RuleBuilderOperator = styled.div`
  padding: 0 8px;
`;

export const Select = styled(AntSelect)<ICustomSelect>`
  &.emp-ant-select {
    .emp-ant-select-selector {
      border-color: rgba(0, 0, 0, 0.06);
      border-radius: 3px;
      background-color: transparent;

      ${({ active }) => {
        if (active) {
          return css`
            background: #e6edff;
          `;
        }
        return;
      }}
      .emp-ant-select-selection-item {
        font-family: 'Roboto', sans-serif;
        font-weight: 500;
        font-size: 12px;
      }
    }
  }
`;
